import React from 'react';
import LazyLoader from '@/components/atoms/UI/LazyLoader/LazyLoader';
import ErrorWithReload from '@/components/molecules/ErrorWithReload/ErrorWithReload';
import ErrorMessage from '@/components/atoms/UI/forms/ErrorMessage/ErrorMessage';

interface LoadingErrorHandlerProps {
    isFetching: boolean;
    error?: string | null;
    onReload?: () => void;
    children?: React.ReactNode;
    isNetworkError?: boolean;  // Добавляем флаг сетевой ошибки
}

const LoadingErrorHandler: React.FC<LoadingErrorHandlerProps> = ({
                                                                     isFetching,
                                                                     error,
                                                                     children,
                                                                     onReload,
                                                                     isNetworkError
                                                                 }) => {
    if (isFetching) {
        return <LazyLoader />;
    }

    if (error) {
        return (
            <>
                {children}
                {isNetworkError ? (
                    <ErrorWithReload error={error} onReload={onReload} />
                ) : (
                    <ErrorMessage>{error}</ErrorMessage>
                )}

            </>
        );
    }

    return <>{children}</>;
};

export default LoadingErrorHandler;
